import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {downloadFile} from '../../../../common/util/file';
import './table.scss';

class LinesList extends Component {
  componentDidUpdate(prevProps) {
    const {urlLinesFile, lineType} = this.props;
    const currentUrl = urlLinesFile[lineType];
    const prevUrl = prevProps.urlLinesFile[lineType];
    if (prevUrl !== currentUrl && currentUrl) {
      downloadFile(currentUrl);
      this.props.clearUrlLinesFile();
    }
  }

  onDownloadClick() {
    const {initialDate, finalDate, lineType, filterType, searchParam} =
      this.props;
    this.props.clearUrlLinesFile();
    this.props.downloadLinesFile(
      {
        initialDate,
        finalDate,
        lineType,
      },
      filterType,
      searchParam
    );
  }

  renderInfoRows() {
    const {lineType, linesDetail, loading} = this.props;
    const data = linesDetail[lineType];

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    if (!data.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={3}>
            No hay información de líneas con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }
    return data.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center' className='filter-label'>
            {element.label}
          </Table.Cell>
          <Table.Cell textAlign='center' colSpan={2}>
            {element.value}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {filterTypeLabel, lineLabel, searchParam} = this.props;
    return (
      <Card raised fluid>
        <Table striped className='lines-info-detail'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center' className='filter-label'>
                {`${filterTypeLabel} ${searchParam && `x ${searchParam}`}`}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='line-type-label'>
                Total líneas {lineLabel}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='right'>
                <div
                  className='download-container'
                  onClick={this.onDownloadClick.bind(this)}
                >
                  <Icon name='download' size='large' />
                  Excel
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderInfoRows()}</Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.cpd.loadingLinesDetail,
    'linesDetail': state.cpd.linesDetail,
    'urlLinesFile': state.cpd.urlLinesFile,
    'searchParam': state.cpd.searchParam[ownProps.lineType],
  };
};

const {
  clearUrlLinesFile,
  downloadLinesFile,
} = Actions;


export default connect(mapStateToProps, {
  clearUrlLinesFile,
  downloadLinesFile,
})(LinesList);
